import React, { useId, useRef } from 'react';
import { LittleCard } from '../../molecules';
import { Container, EntryAnimation } from '../../atoms';
export default function ReportsGridSection(param) {
    var cards = param.cards, className = param.className;
    var id = useId();
    var containerRef = useRef(null);
    return /*#__PURE__*/ React.createElement(Container, {
        ref: containerRef,
        name: ReportsGridSection.name,
        className: className
    }, /*#__PURE__*/ React.createElement("div", {
        className: "grid gap-6 grid-cols-1 grid-flow-row auto-rows-max md:grid-cols-2"
    }, cards.map(function(card, cardIndex) {
        return /*#__PURE__*/ React.createElement(EntryAnimation, {
            key: "card-".concat(id, "-").concat(card.title),
            view: containerRef,
            delay: cardIndex / 20
        }, /*#__PURE__*/ React.createElement(LittleCard, card));
    })));
}

//# sourceMappingURL=ReportsGridSection.js.map